import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Upload, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { api, notifyErr, fetchBlobUrl } from "@/lib/api";

const COLS = [["primary", "Primario"], ["accent", "Accento"], ["sidebar", "Menu laterale"], ["secondary", "Secondario"]];

export function DemoLogo({ id }) {
  const [u, setU] = useState(null);
  useEffect(() => { let url; fetchBlobUrl(`/platform/demo/links/${id}/logo`).then((x) => { url = x; setU(x); }).catch(() => setU(null)); return () => url && URL.revokeObjectURL(url); }, [id]);
  return u ? <img src={u} alt="logo" className="h-7 w-auto max-w-[80px] object-contain bg-white rounded p-0.5" data-testid={`demo-logo-${id}`} /> : null;
}

export function DemoSendDialog({ open, onOpenChange, onSent }) {
  const [f, setF] = useState({});
  const [busy, setBusy] = useState(false);
  const [preview, setPreview] = useState(null);
  useEffect(() => { if (open) { setF({}); setPreview(null); } }, [open]);
  const upload = async (file) => {
    const fd = new FormData(); fd.append("file", file);
    try { const r = await api.post("/platform/demo/logo", fd); setF((s) => ({ ...s, ...r.data, colors: r.data.palette })); setPreview(URL.createObjectURL(file)); toast.success("Logo caricato: colori proposti dal logo"); } catch (e) { notifyErr(e); }
  };
  const send = async (e) => {
    e.preventDefault();
    if (!f.email) return notifyErr({ message: "Inserisci l'email del destinatario" });
    setBusy(true);
    try { const r = await api.post("/platform/demo/send", f); toast.success(r.data.message); onSent(); onOpenChange(false); } catch (err) { notifyErr(err); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl" data-testid="demo-send-dialog">
        <DialogHeader><DialogTitle>Invia prova NOLIUM (accesso demo 24 ore)</DialogTitle></DialogHeader>
        <form onSubmit={send} className="space-y-4">
          <div className="grid sm:grid-cols-2 gap-4">
            <div><Label className="text-xs text-zinc-400">Email destinatario *</Label><Input type="email" value={f.email || ""} onChange={(e) => setF({ ...f, email: e.target.value })} className="mt-1" data-testid="demo-email-input" /></div>
            <div><Label className="text-xs text-zinc-400">Nome società del cliente (vuoto = NOLIUM Demo)</Label><Input value={f.brand_name || ""} onChange={(e) => setF({ ...f, brand_name: e.target.value })} className="mt-1" data-testid="demo-brand-name-input" /></div>
          </div>
          <div className="flex items-center gap-4">
            <label className="inline-flex items-center gap-2 px-4 h-10 rounded-md border border-zinc-700 cursor-pointer hover:border-brand text-sm" data-testid="demo-logo-upload">
              <input type="file" accept="image/png,image/jpeg" className="hidden" data-testid="demo-logo-input" onChange={(e) => e.target.files[0] && upload(e.target.files[0])} /><Upload size={15} />Carica logo (ricava colori)</label>
            {preview ? <img src={preview} alt="logo" className="h-10 w-auto max-w-[140px] object-contain bg-white rounded p-1" data-testid="demo-logo-preview" /> : <span className="text-xs text-zinc-500">Senza logo la demo usa logo e colori NOLIUM.</span>}
          </div>
          {f.colors && <div className="grid grid-cols-2 sm:grid-cols-4 gap-3" data-testid="demo-colors">
            {COLS.map(([k, l]) => <div key={k}><Label className="text-xs text-zinc-400">{l}</Label>
              <input type="color" value={f.colors[k] || "#000000"} onChange={(e) => setF({ ...f, colors: { ...f.colors, [k]: e.target.value.toUpperCase() } })} className="mt-1 h-10 w-full bg-transparent" data-testid={`demo-color-${k}`} /></div>)}
          </div>}
          <DialogFooter>
            <Button type="button" variant="outline" onClick={() => onOpenChange(false)}>Annulla</Button>
            <Button type="submit" disabled={busy} data-testid="demo-send-submit">{busy && <Loader2 className="animate-spin mr-1" size={14} />}Invia prova</Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
